const replaceSpaceWithHyphen = s => s.replace(/ +/g, '-');

export default replaceSpaceWithHyphen;
